import React from "react";
import {
	Button,
	Flex,
	Stack,
	Title,
	Text,
	Input,
	Divider,
	Anchor,
	Group,
	List,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useDisclosure } from "@mantine/hooks";
import { Link } from "react-router-dom";

const LoginUserSection = ({
	name,
	email,
	isSubmitting,
	handleLogin,
	handleWaitlist,
	setName,
	setEmail,
}) => {
	const { t, i18n } = useTranslation();
	const [tosModalOpened, { open: openTos, close: closeTos }] =
		useDisclosure(false);
	const [privacyModalOpened, { open: openPrivacy, close: closePrivacy }] =
		useDisclosure(false);

	const termsText =
		i18n.language === "ko" ? (
			<>
				"시작하기"를 클릭하면{" "}
				<Anchor component={Link} c="inform" to="/terms" target="_blank" fw={800} underline="always">
					서비스 이용약관
				</Anchor>
				와{" "}
				<Anchor component={Link} c="inform" to="/privacy" target="_blank" fw={800} underline="always">
					개인정보 처리방침
				</Anchor>
				에<br/>동의하는 것으로 간주됩니다
			</>
		) : (
			<>
				By clicking "Get Started", you agree to our<br/>
				<Anchor component={Link} to="/terms" fw={800} underline="always">
					Terms of Service
				</Anchor>{" "}
				and{" "}
				<Anchor component={Link} to="/privacy" fw={800} underline="always">
					Privacy Policy
				</Anchor>
			</>
		);

	return (
		<>
			{/* Beta Tester */}
			<Flex
				w={"100%"}
				direction={"column"}
				justify={"center"}
				align={"center"}
				gap={"1.5rem"}
			>
				{/* <Divider w={"100%"} /> */}
				<Stack gap={"0"} align={"center"}>
					{/* <Title order={2} fw={900}>
            {t("landing.titleBetaTest")}
          </Title> */}
					{/* <Text size="xl">
            {t("landing.descriptionBetaTest")}
          </Text> */}
				</Stack>
				<svg
					width="24"
					height="80"
					viewBox="0 0 24 80"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M10.9393 79.0607C11.5251 79.6464 12.4749 79.6464 13.0607 79.0607L22.6066 69.5147C23.1924 68.9289 23.1924 67.9792 22.6066 67.3934C22.0208 66.8076 21.0711 66.8076 20.4853 67.3934L12 75.8787L3.51472 67.3934C2.92893 66.8076 1.97919 66.8076 1.3934 67.3934C0.807611 67.9792 0.807611 68.9289 1.3934 69.5147L10.9393 79.0607ZM10.5 0L10.5 78H13.5L13.5 0L10.5 0Z"
						fill="var(--mantine-color-gray-9)"
					/>
				</svg>
				<Stack align="center" gap={24}>
					<Text size="lg" ta="center" co="inform.9">
						{termsText}
					</Text>
					<Button w={256} size="xl" radius={"xl"} color="inform" onClick={handleLogin}>
						{t("landing.getStarted")}
					</Button>
				</Stack>
			</Flex>
		</>
	);
};

export default LoginUserSection;
